// extracted by mini-css-extract-plugin
export default {"imagesWrapper":"bG-z"};